export default __webpack_public_path__ + "static/media/struggle-is-real.322cc867.md";